const styles = {
  addAnother: {
    textTransform: "none",
    ml: 1,
  },
  skeletonGroup: { px: 3, mt: 2, mb: 10 },
};

export default styles;
